import React from "react";
import styled from "styled-components";
import Boleto from "../../../assets/kinologyIcons/svg/boleto.svg";
import Copy from "../../../assets/kinologyIcons/svg/copy.svg";
import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { FinancialActions } from "../../../store/ducks/financial";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);
export  interface whiteListProps {
	ID_RESPOSTA_WHITELIST: number;
	ID_FATURA: string;
	RESPOSTA_WHITELIST_VALOR: string;
	RESPOSTA_WHITELIST_CRIADO: string;
};


const ModalBoleto: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const current_language = useSelector(
		(state: any) => state.configs.current_language
	);

	const is_open_modal_boleto = useSelector(
		(state: any) => state.financial.modal_boleto
	);

	const boleto = useSelector((state: any) => state.financial.fatura_selecionada);
	const lastDataWhitelist: whiteListProps = useSelector((state: any) => state.financial.last_data_white_list);
	const inadimplencia_motivo = useSelector(
		(state: any) => state.configs.config_inadimplencia?.INADIMPLENCIA_MOTIVO
	) as string;
	const valor = boleto?.FATURA_VALOR || 0;

	const formatPrice = (price: number) =>
		(price / 100)?.toFixed(2).replace(/\./g, ",");

	const handleCopy = () => {
		navigator.clipboard.writeText(boleto?.[boleto.length -1]?.codigo?.toString());
		alert(current_language?.codigo_boleto_copiado);
	};

	const ModalClose = () => {
		dispatch(FinancialActions.set_modal_boleto(false));
		if(!lastDataWhitelist){
			dispatch(FinancialActions.set_modal_melhor_momento(true));
		}else{
			dispatch(FinancialActions.set_modal_falha_pagamento(true,inadimplencia_motivo))
		}
	};

	const FezPagamento = () => {
		if(lastDataWhitelist){
			dispatch(FinancialActions.set_modal_boleto(false));
			dispatch(FinancialActions.set_modal_pagamento_processado(true, 'paymentPromess'));
		}else{
			const numberOfDays = 2
			dispatch(FinancialActions.set_request_add_user_in_white_list(numberOfDays))
		}
	};


	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={is_open_modal_boleto}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={is_open_modal_boleto}>
				<ModalContainer>
					<ModalContent>
						<CloseButton onClick={() => ModalClose()}>×</CloseButton>
						<IconContainer>
							<img style={{ width: "4rem", height: "4rem" }} src={Boleto} />
						</IconContainer>
						<Title>{current_language?.copie_codigo_ou_baixe}</Title>
						<Title>{current_language?.valor_boleto}</Title>
						<Title>R$ {formatPrice(valor)}</Title>
						<Title>{current_language?.codigo_boleto}</Title>
						<CodeContainer
							onClick={()=>handleCopy()}
						>
							{boleto?.[boleto.length -1]?.codigo?.toString()}
						</CodeContainer>
						<Button primary onClick={handleCopy}>
							{current_language?.copiar_codigo_boleto}
						</Button>
						<Button
							onClick={()=> window.open(boleto?.[boleto.length -1]?.pdf,'_blank')}
						>
							<a target="_blank" rel="noopener noreferrer">
								{current_language?.baixar_boleto}
							</a>
						</Button>
						<Button onClick={() => FezPagamento()}>
							{current_language?.ja_fiz_pagamento}
						</Button>
					</ModalContent>
				</ModalContainer>
			</Fade>
		</Modal>
	);
};

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
`;

const ModalContent = styled.div`
	background: white;
	padding: 20px;
	border-radius: 0.75rem;
	max-width: 25%;
	width: 100%;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	position: relative;
`;

const CloseButton = styled.button`
	position: absolute;
	top: 10px;
	right: 10px;
	background: none;
	border: none;
	font-size: 30px;
	cursor: pointer;
`;

const IconContainer = styled.div`
	color: #0080ff;
	margin-bottom: 16px;
`;

const Title = styled.h2`
	font-size: 16px;
	color: #002060;
	margin: 0 0 16px;
`;

const CodeContainer = styled.div`
	font-size: 14px;
	color: #333;
	padding: 10px;
	border-radius: 0.75rem;
	margin-bottom: 16px;
	cursor: pointer;
	word-wrap: break-word;
	white-space: pre-wrap;
`;

const Button = styled.button<ButtonProps>`
	width: 100%;
	padding: 12px;
	font-size: 14px;
	font-weight: bold;
	color: ${({ primary }) => (primary ? "white" : "#009973")};
	background-color: ${({ primary }) => (primary ? "#009973" : "white")};
	border: ${({ primary }) => (primary ? "none" : "1px solid #00a859")};
	border-radius: 0.75rem;
	margin-bottom: 8px;
	cursor: pointer;
	&:hover {
		background-color: ${({ primary }) => (primary ? "#009973" : "#f6f6f6")};
	}
	&:disabled {
		background-color: #ccc;
		color: #777;
		cursor: not-allowed;
	}
`;

interface ButtonProps {
	primary?: boolean;
}

export default ModalBoleto;
